import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { ReportlinksserviceService } from "src/app/user/reportlinks/reportlinksservice.service";
import { ReviewActivityPopupConfigComponent } from "src/app/user/review-activity-config/review-activity-popup-config/review-activity-popup-config.component";

@Component({
    selector: "app-new-adhoc-activity-popup",
    templateUrl: "./new-adhoc-activity-popup.component.html",
    styleUrls: ["./new-adhoc-activity-popup.component.scss"],
    standalone: false
})
export class NewAdhocActivityPopupComponent implements OnInit {
  titleText = "Add Ad-Hoc Review Activity";
  backgroundColorScreen = "";
  buttonColor = "";
  adhocActivityForm!: FormGroup;
  showConfigForm = false;
  pssList: any[] = [];
  activitiesList: any;
  levels: any;
  reviewPeriods = ["Weekly","Monthly", "Quarterly","HalfYearly", "Yearly"];
  Accesstypes: any[] = [];
  //keys are lookuptype , assignTo :-  are property to which lookup need to be added
  lookups = [
    // { key: "activityOptions", assignTo: "activitiesList" },
    { key: "ActivityLevel", assignTo: "levels" },
  ];
  backgroundColorButton = "";

  minDate = new Date();
  isOtherSelected = false;
  reviewPeriodDays: any = {
  Weekly: 7,
  Monthly: 30,
  Quarterly: 90,
  HalfYearly: 180,
  Yearly: 365
};
  UserRoleName: any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NewAdhocActivityPopupComponent>,
    private snackBar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private jsignalsService: JsignalService,
    private spinner: NgxUiLoaderService,
    private commonService: CommonService,
    private service: ReportingServiceService,
    private validate: validationmethod,
    private linkservice: ReportlinksserviceService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.Useroles();
    this.fetchlookupvalue();
    this.fetchUserRole();
    this.loadActiveReviewActivities();
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton =  this.localStorageSettings.getSettings("ColorA");
    // Initialize dropdown data
    this.pssList = this.data; // from parent grid row
    console.log("Received PSS List:", this.pssList);
    this.minDate = new Date(); // sets today as the minimum selectable date

    this.buildForm();
    // Set the Period Map for selected Review Period 
    this.adhocActivityForm.get('reviewPeriod')?.valueChanges.subscribe(period => {
      if (period && this.reviewPeriodDays[period]) {
        this.adhocActivityForm.get('dueDays')?.setValue(this.reviewPeriodDays[period], { emitEvent: false });
      }
    });
  }

  buildForm() {
    this.adhocActivityForm = this.fb.group({
      pssName: ["", Validators.required],
      activityName: ["", Validators.required],
      level: ["", Validators.required],
      reviewPeriod: ["", Validators.required],
      dueDays: [30, [Validators.required, Validators.min(1)]],
      startDate: [null, Validators.required],
      durationHours: [1, [Validators.required, Validators.min(1)]],
      evidenceRequired: ["Yes", Validators.required],
      uploadInstructions: ["",this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore],
      // rolesAllowed: [[], Validators.required],
      activitySelect: ["", Validators.required], // dropdown UI
      endDate:[null, Validators.required],
      descriptionForNewActivity: ["",[Validators.required, this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]]
      
    });
  }

  onActivitySelect() {
    const selectedPSS = this.adhocActivityForm.get("pssName")?.value;
    const selectedActivity = this.adhocActivityForm.get("activityName")?.value;

    // Show configuration form only when both are selected
    this.showConfigForm = !!(selectedPSS && selectedActivity);
  }

  submit() {
    if (this.adhocActivityForm.invalid) return;

    const form = this.adhocActivityForm.value;
    console.log("form value",form)

    let pssId = form.pssName.PSSID;
    console.log("PSSID Inside Ad Hoc Sumbit", pssId)

    console.log("activitydescripition",form.descriptionForNewActivity);

    const payload = {
        activity:form.activityName,
        level: form.level,
        reviewPeriod: form.reviewPeriod,
        dueDays: form.dueDays,
        startDate: form.startDate,
        durationHours: form.durationHours,
        evidenceRequired: form.evidenceRequired,
        uploadInstructions: form.uploadInstructions,
        // rolesAllowed: Array.isArray(form.rolesAllowed)
        //   ? form.rolesAllowed.join(",")
        //   : form.rolesAllowed,
        endDate:form.endDate,
        activitydescripition:form.descriptionForNewActivity,
    };
    console.log("Submitting payload:", payload);
    this.spinner.start();
    this.jsignalsService
      .createNewAdhocReviewActivity(pssId,payload)
      .subscribe({
        next: (res: any) => {
        this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
        console.log(res);
        this.spinner.stop();

        if (!res.error) {
          this.dialogRef.close(true); //Close only when no error
        }
      },
      error: (err) => {
        console.error("error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", {
          duration: 3000,
        });
        this.spinner.stop();
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
  onNext() {
    if (
      this.adhocActivityForm.get("pssName")?.invalid ||
      this.adhocActivityForm.get("activityName")?.invalid
    ) {
      this.adhocActivityForm.get("pssName")?.markAsTouched();
      this.adhocActivityForm.get("activityName")?.markAsTouched();
      return;
    }

    this.showConfigForm = true;
  }

  fetchlookupvalue() {
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          //         // this.loadGridData();
          this.spinner.stop();
        },
      });
    });
  }

  // Fetch all available User Roles for given dnsid
  Useroles(): void {
    const dnsid = this.localStorageSettings.getSettings("dnsName");
    if (dnsid) {
      //this.service.
      this.service
        .getUserRoles(this.localStorageSettings.getSettings("dnsName"))
        .subscribe(
          (response) => {
            this.Accesstypes = response; // Assign fetched user roles to the types array
            console.log(this.Accesstypes);
          },
          (error) => {
            console.error("Error fetching user roles:", error);
          }
        );
    }
  }
  backtoSelection(){
    this.showConfigForm = false;
  }
  onActivityChange(value: string) {
  this.isOtherSelected = value === 'Others';

  const nameControl = this.adhocActivityForm.get('activityName');

  if (this.isOtherSelected) {
     
    this.dialog.open(ReviewActivityPopupConfigComponent, {
          maxWidth: "100vw",
          height: "40%",
          width: "60%",
          disableClose: true,
        })
      .afterClosed()
      .subscribe((result) => {
         console.log(result);
         this.adhocActivityForm.get('activitySelect')?.setValue(null);
        if (result) {
        this.loadActiveReviewActivities(); // Refresh the activities list to include the new activity
        }
      });
    // nameControl?.setValidators([
    //   Validators.required,
    //   this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore
    // ]);
    // nameControl?.updateValueAndValidity();
    // nameControl?.reset(); // clear old name
  } else {
    nameControl?.clearValidators();
    nameControl?.updateValueAndValidity();
    nameControl?.setValue(value); // store selected activity
  }
}

updateCustomActivity(event: any) {
  const customValue = event.target.value;
  this.adhocActivityForm.get('activityName')?.setValue(customValue);
}
fetchUserRole() {
    this.linkservice
      .fetchUserRole(
        this.localStorageSettings.getSettings("dnsName"),
        this.localStorageSettings.getSettings("AuthUsername")
      )
      .subscribe((res: any) => {
        console.log(res.roleName);
        this.UserRoleName = res.roleName;
          // Patch directly into form
    this.adhocActivityForm.patchValue({
      // rolesAllowed: [this.UserRoleName]
    });

    // If needed mark touched/valid
    // this.adhocActivityForm.get('rolesAllowed')?.updateValueAndValidity();
  });
  }
  onPssSelected(selectedPss: any) {
  if (!selectedPss) return;

  const level = selectedPss.level; 

  // Patch the level into form
  this.adhocActivityForm.patchValue({
    level: level
  });
}


  loadActiveReviewActivities(){
    this.jsignalsService
      .getAllActiveReviewActivityConfigs()
      .subscribe({
        next: (res: any) => {
     
          this.activitiesList = res;
          console.log("Active Review Activities loaded:", res);
          this.spinner.stop();
     
        },
        error: (err) => {
          console.error(" error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
          this.activitiesList = [];
          this.spinner.stop();
        },
      });
  }
}
